import LocalizedStrings from 'react-localization';
import { languages } from 'cv-react-core';

const lang = new LocalizedStrings({
    'en-US': languages.english.en,
    en: languages.english.en,
});

export default lang;
